module.exports = __webpack_public_path__ + "img/diamondjewelry-mobile.2c71ed4.jpg";